import { inventoryModul_get_all_cabang_reducers } from "../reducers/InventoryAllCabangReducers";
import { inventoryModul_get_cabang_reducers } from "../reducers/InventoryCabangReducers";

const modulInventory = {
  inventoryModul_get_all_cabang: inventoryModul_get_all_cabang_reducers,
  inventoryModul_get_cabang: inventoryModul_get_cabang_reducers,
};

export default modulInventory;
